import HtaConnector from './HtaConnector'
export default HtaConnector
